<template>
    <div>
        <v-autocomplete
            @keyup="setCitySearch"
            @change="applyCityFilter"
            @click:clear="clearCityFilter"
            :label="$t('genericFilters.label.city')"
            :no-data-text="$t('appointment.filters.noData')"
            :loading="cityLoading"
            :items="cities"
            item-text="name"
            item-value="id"
            return-object
            hide-no-data
            clearable
            outlined
            dense
        >
            <template v-slot:selection="data">
                {{ data.item.name }}/{{ data.item.state.acronym }}
            </template>
            <template v-slot:item="data">
                {{ data.item.name }}/{{ data.item.state.acronym }}
            </template>
        </v-autocomplete>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
    name: "CitySelectFilter",
    props: {
        fetchData: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            timer: null,
            cityLoading: false,
        }
    },
    computed: {
        ...mapGetters(['isLoading', 'cities', 'filters']),
    },

    methods: {
        ...mapActions(['fetchCitiesPaginated']),
        ...mapMutations(['setFilters', 'setCities']),

        setCitySearch({ target }) {
            this.cityLoading = true

            clearTimeout(this.timer)

            this.timer = setTimeout(() => {
                this.setFilters({ search: target.value })

                this.fetchCitiesPaginated().finally(() => {
                    this.cityLoading = false
                })

                this.setFilters({
                    ...this.$store.getters.filters,
                    ...{ search: null },
                })
            }, 500)
        },

        applyCityFilter(city) {
            if (city) {
                this.setFilters({
                ...this.$store.getters.filters,
                ...{ cityId: city.id },
                })
                this.fetchData()
                this.$emit("cityFilterChange")
            }
        },

        clearCityFilter() {
            this.cityLoading = false
            this.setFilters({
                ...this.$store.getters.filters,
                ...{ cityId: null },
            })
            this.fetchData()
            this.$emit("cityFilterChange")
        },
    }
}
</script>
